import { createSelector } from 'reselect';
import { prop } from 'ramda';
import { matchPath } from 'react-router-dom';

import { getUserId } from 'store/selectors/user';

const localState = prop('router');

export const getLocation = createSelector(
  localState,
  prop('location'),
);

export const getLocationPath = createSelector(
  getLocation,
  prop('pathname'),
);

export const getPatientPageUrlParams = createSelector(
  getLocationPath,
  pathname => {
    const matching = matchPath(pathname, '/patient/:patientId');
    return prop('params', matching);
  },
);

export const getPatientPageUrlId = createSelector(
  getPatientPageUrlParams,
  prop('patientId'),
);

export const getPatientPageRequestParams = createSelector(
  getPatientPageUrlId,
  getUserId,
  (patientId, userId) => ({
    patientId,
    userId,
  }),
);
